import React from "react";

const Section = ({ children, bg }) => {
  
  return (
    <div className={`home-section-div ${bg ? bg : "bg-inherit"} `}>
      <div className="padding-global">
        <div className="grid grid-cols-12 auto-rows-auto gap-x-[21px] gap-y-0 mx-auto xl:max-w-[1810px] 2xl:max-w-[2810px] w-full text-primary-light ">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Section;
